import React from 'react';
import { ArrowLeftOutlined, ClockCircleOutlined, CalendarOutlined, EnvironmentOutlined, CheckCircleFilled } from '@ant-design/icons';
import { formatDuration } from './helpers';
import {
  StepHeader,
  ProgressSteps,
  ProgressStep,
  StepCircle,
  StepLabel,
  EventInfoCard,
  EventIconWrapper,
  EventDetails,
  EventMeta,
  MetaItem,
  BackLink,
} from './styled';

const EventInfoHeader = ({ eventType, onBack }) => {
  return (
    <>
      <div style={{ marginBottom: '20px' }}>
        <BackLink onClick={onBack}>
          <ArrowLeftOutlined style={{ fontSize: '12px' }} />
          Back to Services
        </BackLink>
      </div>
      
      <StepHeader>
        {/* Progress Steps */}
        <ProgressSteps>
          <ProgressStep completed nextActive>
            <StepCircle completed>
              <CheckCircleFilled />
            </StepCircle>
            <StepLabel>Select Service</StepLabel>
          </ProgressStep>
          
          <ProgressStep>
            <StepCircle active>2</StepCircle>
            <StepLabel active>Date & Time</StepLabel>
          </ProgressStep>
          
          <ProgressStep>
            <StepCircle>3</StepCircle>
            <StepLabel>Your Information</StepLabel>
          </ProgressStep>
          
          <ProgressStep>
            <StepCircle>4</StepCircle>
            <StepLabel>Confirmation</StepLabel>
          </ProgressStep>
        </ProgressSteps>

        {/* Event Info Card */}
        <EventInfoCard color={eventType.color}>
          <EventIconWrapper color={eventType.color}>
            <CalendarOutlined />
          </EventIconWrapper>
          
          <EventDetails>
            <h3>{eventType.name}</h3>
            <EventMeta>
              <MetaItem color={eventType.color}>
                <ClockCircleOutlined />
                <span>{formatDuration(eventType.duration)}</span>
              </MetaItem>
              <MetaItem color={eventType.color}>
                <EnvironmentOutlined />
                <span>Central Time (CST)</span>
              </MetaItem>
            </EventMeta>
          </EventDetails>
        </EventInfoCard>
      </StepHeader>
    </>
  );
};

export default EventInfoHeader;
